import React, { useEffect, useState } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Container,
  Offcanvas,
  Badge,
  Tabs,
  Tab,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import useAppLoginStore from "./store";
import moment from "moment";
import { isEmpty } from "lodash";
import PaginationDiv from "modules/pagination/PaginationDiv";
import NoData from "assets/svgs/no_data/NoData";
import { fourPlaceHolder } from "modules/utilities/utility";
import { TabletOutlined } from "@ant-design/icons";
import { Pagination, Table } from "antd";
import MoengageEventDetails from "./MoengageEventDetails";

function Userlog() {
  const { appLoginDetails, fetchAppLoginDetails, totalItems, isLoading } =
    useAppLoginStore();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    if (id && show) {
      fetchAppLoginDetails(id, currentPage);
    }
  }, [id, currentPage, show]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(totalItems / pageSize);

  const columns = [
    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
      render: (text) => text || '-',
      fixed: "left",
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      render: (text) => text || '-',
      fixed: "left",
    },
    {
      title: 'Country Name',
      dataIndex: 'countryName',
      key: 'countryName',
      render: (text) => text || '-',
      width: 100
    },
    {
      title: 'Country Code',
      dataIndex: 'countryCode',
      key: 'countryCode',
      render: (text) => text || '-',
      width: 100
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'Pincode',
      dataIndex: 'pinCode',
      key: 'pinCode',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
      render: (text) => text || '-',
    },
    {
      title: 'OS Version',
      dataIndex: 'osVersion',
      key: 'osVersion',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      key: 'platform',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'App Version',
      dataIndex: 'appVersion',
      key: 'appVersion',
      render: (text) => text || '-',
      width: 200
    },
    {
      title: 'Build Number',
      dataIndex: 'buildNumber',
      key: 'buildNumber',
      render: (text) => text || '-',
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <Badge bg={isActive ? "success" : "danger"}>
          {isActive ? "Yes" : "No"}
        </Badge>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
      width: 200
    },
  ];

  return (
    <>
      <div variant="primary" className="">
        <div className="d-flex">
          <OverlayTrigger
            overlay={
              <Tooltip id="overlay-trigger-example">
                <div className="fw-bold">User Activity</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer fs-3 text-black mt-2"
              onClick={handleShow}
            >
              <TabletOutlined />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "70%" }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="text-primary fw-bold m-1">User Activity</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>

          <Tabs defaultActiveKey="app-activity" id="uncontrolled-tab-example">
            <Tab eventKey="app-activity" title="App Activity" className='border-bottom border-x p-3'>
              <>
                {isLoading ? (
                  fourPlaceHolder()
                ) : !isEmpty(appLoginDetails) ? (
                  <>
                    <Table
                      columns={columns}
                      dataSource={appLoginDetails}
                      pagination={false}
                      rowKey={(record) => record.id}
                      scroll={{
                        x: 2400,
                        y: 600
                      }}
                    />
                    <Pagination
                      current={currentPage}
                      pageSize={pageSize}
                      total={totalItems}
                      onChange={handlePageChange}
                      className='d-flex justify-content-center align-items-center mt-3'
                    />
                  </>
                ) : (
                  <div className="d-flex justify-content-center p-2 border rounded">
                    No activity data available. <NoData />
                  </div>
                )}
              </>
            </Tab>
            <Tab eventKey="Moengage Events logs" title="Moengage Events logs" className='border-bottom border-x p-3'>
              <MoengageEventDetails />
            </Tab>
          </Tabs>



        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Userlog;
